import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import useGameSocket from '../utils/useGameSocket';

export default function useTourneyRankingLeaderboard(tempTableId) {
    const tourneyRankingLeaderboardDetails = useSelector((state) => state.gameTable.games[tempTableId]?.tourneyRankingLeaderboardDetails)
    const isTourneyRankingLeaderboardRequestInProgress = useSelector((state) => state.gameTable.games[tempTableId]?.isTourneyRankingLeaderboardRequestInProgress);
    const gameDefinition = useSelector((state) => state.gameTable.games[tempTableId]?.gameDefinition);
    const { sendTourneyRankingLeaderboardRequest } = useGameSocket(tempTableId);
    // const { connected } = useGameConnection();
    const [loading, setLoading] = useState(false);

    const requestTourneyRankingData = () => {
        // console.log('Spruha log >>> Sending Tourney Ranking Leaderboard Request')
        setLoading(true);
        sendTourneyRankingLeaderboardRequest(gameDefinition?.tourneyId);
    }

    useEffect(() => {
        if (!isTourneyRankingLeaderboardRequestInProgress) {
            setLoading(false);
        }
    }, [isTourneyRankingLeaderboardRequestInProgress])

    if (!tourneyRankingLeaderboardDetails || !gameDefinition) {
        // console.error('Missing Tourney Ranking Leaderboard Details >>> ', tourneyRankingLeaderboardDetails, gameDefinition)
        return {
            tourneyRankingLeaderboardDetails: {},
            gameDefinition: {},
            loading,
            requestTourneyRankingData
        }
    }

    return { tourneyRankingLeaderboardDetails, gameDefinition, loading, requestTourneyRankingData };
}
